import React from 'react';

import { Box, Button, Sheet, Stack, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { layoutStore } from './LayoutStore';

const LayoutSettingsWidget: React.FC = observer(() => {
  const [open, setOpen] = React.useState(false);
  const { reset } = layoutStore;

  return (
    <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
      <Button size='sm' onClick={() => setOpen(!open)} variant='soft'>
        Layout
      </Button>
      {open && (
        <Sheet variant='outlined' sx={{ p: 2, mt: 1, width: 200 }}>
          <Stack spacing={1}>
            <Typography level='body-sm'>Layout Options</Typography>
            <Button size='sm' onClick={() => layoutStore.reset()}>
              Reset Layout
            </Button>
          </Stack>
        </Sheet>
      )}
    </Box>
  );
});

export default LayoutSettingsWidget;
